import { render, staticRenderFns } from "./SponsoredRecommendationVideo.vue?vue&type=template&id=d5d428e6&scoped=true"
import script from "./SponsoredRecommendationVideo.vue?vue&type=script&setup=true&lang=ts"
export * from "./SponsoredRecommendationVideo.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SponsoredRecommendationVideo.vue?vue&type=style&index=0&id=d5d428e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5d428e6",
  null
  
)

export default component.exports